// Adapted from the @shadcndesign app-shell-4 NavMain block.
import React from "react";
import { NavLink } from "react-router-dom";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuBadge,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/shadcn/components/ui/sidebar";

const SidebarNavMenu = ({ items, pathname, onNavigate, className }) => (
  <SidebarGroup className={className}>
    <SidebarGroupContent>
      <SidebarMenu>
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = Boolean(
            (item.path && pathname.includes(item.path)) || item.drawerOpened
          );
          const tooltip =
            item.badge > 0 ? `${item.label} (${item.badge})` : item.label;
          const content = (
            <>
              <Icon aria-hidden="true" />
              <span>{item.label}</span>
            </>
          );

          return (
            <SidebarMenuItem key={item.path || item.label}>
              {item.onClick ? (
                <SidebarMenuButton
                  isActive={isActive}
                  tooltip={tooltip}
                  aria-expanded={Boolean(item.drawerOpened)}
                  onClick={() => {
                    item.onClick();
                    onNavigate?.();
                  }}
                >
                  {content}
                </SidebarMenuButton>
              ) : (
                <SidebarMenuButton
                  isActive={isActive}
                  tooltip={tooltip}
                  render={<NavLink to={item.path} onClick={onNavigate} />}
                >
                  {content}
                </SidebarMenuButton>
              )}
              {item.badge > 0 && (
                <>
                  <SidebarMenuBadge>{item.badge}</SidebarMenuBadge>
                  {/* The count hides when the sidebar folds to icons; a dot
                      on the icon keeps it visible. */}
                  <span
                    aria-hidden="true"
                    className="pointer-events-none absolute top-1 right-1 hidden size-2 rounded-full bg-primary group-data-[collapsible=icon]:block"
                  />
                </>
              )}
            </SidebarMenuItem>
          );
        })}
      </SidebarMenu>
    </SidebarGroupContent>
  </SidebarGroup>
);

export default SidebarNavMenu;
